import { post } from 'aws-amplify/api';
import { PRESCRIPTSURE } from '../constants/api-endpoints';
import { getSessionToken } from './service-config';
const apiNamePath = PRESCRIPTSURE.SA_USER_API;

const superAdminApiService = {
  async listOrganizationUsers(
    limit,
    searchTerm,
    pageNumber,
    shouldPaginate = 0,
  ) {
    const sessionToken = await getSessionToken();

    const listOrganizationsOperation = post({
      apiName: apiNamePath,
      path: '/organization_user_list',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          limit: limit,
          search_term: searchTerm,
          page_number: pageNumber,
          should_paginate: shouldPaginate,
        },
      },
    });

    const listOrganizationsResult = (
      await listOrganizationsOperation.response
    ).body.json();

    return listOrganizationsResult;
  },

  async getSpecialOrganizations() {
    const sessionToken = await getSessionToken();

    const getSpecialOrganizationsOperation = post({
      apiName: apiNamePath,
      path: '/exception_user_list',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'get_exception_users',
        },
      },
    });

    const getSpecialOrganizationsResult = (
      await getSpecialOrganizationsOperation.response
    ).body.json();

    return getSpecialOrganizationsResult;
  },

  async setForceAllow(orgId, value) {
    const sessionToken = await getSessionToken();

    const operation = post({
      apiName: apiNamePath,
      path: '/set_force_allow',
      options: {
        headers: { Authorization: `Bearer ${sessionToken}` },
        body: { org_id: orgId, value },
      },
    });

    return (await operation.response).body.json();
  },

  async getOrgDetails(userName) {
    const sessionToken = await getSessionToken();

    const operation = post({
      apiName: apiNamePath,
      path: '/organization_user_list',
      options: {
        headers: { Authorization: `Bearer ${sessionToken}` },
        body: { user_name_filter: userName },
      },
    });

    const result = await (await operation.response).body.json();
    return result?.results?.[0] ?? null;
  },

  async updateSpecialOrganizations(organizationEmails) {
    const sessionToken = await getSessionToken();

    const updateSpecialOrganizationsOperation = post({
      apiName: apiNamePath,
      path: '/exception_user_list',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'update_exception_users',
          emails: organizationEmails,
        },
      },
    });

    const updateSpecialOrganizationsResult = (
      await updateSpecialOrganizationsOperation.response
    ).body.json();

    return updateSpecialOrganizationsResult;
  },
};

export default superAdminApiService;
